<template>
  <nav
    :class="['d-navbar', { 'd-navbar-scrolled': isScrolled, 'd-mobile-menu-open': isMobileMenuOpen }]"
    ref="navbar">
    <div class="d-navbar-container">
      <a href="/" :class="['d-navbar-brand', { 'd-navbar-brand-scrolled': isScrolled, 'd-mobile-menu-open-link': isMobileMenuOpen }]">Dynalab</a>

      <div v-on:click="toggleMobileMenu" class="d-mobile-navbar-toggle">
        <span :class="['d-mobile-navbar-btn', { 'd-mobile-navbar-btn-scrolled': isScrolled, 'd-mobile-menu-open-link': isMobileMenuOpen }]"><i class="fas fa-bars"></i></span>
      </div>

      <div v-if="isMobileMenuOpen" class="d-mobile-navbar-menu">
        <ul>
          <li>
            <router-link to="/Services">{{services}}</router-link>
            <ul class="d-mobile-sub-ul">
              <li><router-link to="/Services/Consulting">Professional Services</router-link></li>
              <li><router-link to="/Services/GIS">Geographical Information Systems (GIS)</router-link></li>
              <li><router-link to="/Services/BI">Business Intelligence (BI)</router-link></li>
            </ul>       
          </li>
          <li>
            <router-link to="/About">{{about.about}}</router-link>
            <ul class="d-mobile-sub-ul">
              <li><router-link to="/About/Dynateam">Dynateam</router-link></li>
              <li><router-link to="/About/Customers">{{about.customers}}</router-link></li>
            </ul>
          </li>
          <li>
            <router-link to="/Contact">{{contact}}</router-link>
          </li>
          <li style="text-align: center; margin-top: 10px;">
            <a style="font-size: 13px;" v-on:click="changeLanguage">{{languageControl}}</a>
          </li>
        </ul>
      </div>
      
      <ul class="d-navbar-menu">
        <!-- Tjänster -->
        <li
          :class="['d-navbar-item', 'd-navbar-dd-item', { 'd-navbar-item-scrolled': isScrolled, 'd-navbar-item-dd-hover': dropdownVisible.Tjänster }]"
          @mouseover="showDropdown('Tjänster')"
          @mouseleave="hideDropdown('Tjänster')">
          <router-link to="/Services">{{services}}</router-link>
          <ul v-if="dropdownVisible.Tjänster" class="d-dropdown-menu">          
            <li class="d-dropdown-item"><router-link to="/Services/Consulting">Professional Services</router-link></li>
            <li class="d-dropdown-item"><router-link to="/Services/GIS">Geographical Information Systems (GIS)</router-link></li>
            <li class="d-dropdown-item"><router-link to="/Services/BI">Business Intelligence (BI)</router-link></li>
          </ul>
        </li>

        <!-- Om -->
        <li
          :class="['d-navbar-item', 'd-navbar-dd-item', { 'd-navbar-item-scrolled': isScrolled, 'd-navbar-item-dd-hover': dropdownVisible.Om }]"
          @mouseover="showDropdown('Om')"
          @mouseleave="hideDropdown('Om')">
          <router-link to="/About">{{about.about}}</router-link>
          <ul v-if="dropdownVisible.Om" class="d-dropdown-menu">
            <li class="d-dropdown-item"><router-link to="/About/Dynateam">Dynateam</router-link></li>
            <li class="d-dropdown-item"><router-link to="/About/Customers">{{about.customers}}</router-link></li>
          </ul>
        </li>

        <!-- Kontakta oss -->
        <li :class="['d-navbar-item', { 'd-navbar-item-scrolled': isScrolled }]">
          <router-link to="/Contact">{{contact}}</router-link>
        </li>

        <!-- Language -->
        <li :class="['d-navbar-item','languageControl', { 'd-navbar-item-scrolled': isScrolled }]">
          <a v-on:click="changeLanguage" href="#">{{languageControl}}</a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Navbar",
  props: ["language", "loggedIn"],
  data() {
    return {
      isScrolled: false,
      isMobileMenuOpen: false,
      dropdownVisible: {
        Tjänster: false,
        Om: false,
      },
      services: this.$root.getHeader(0),
      about: {
        about: this.$root.getHeader(2),
        customers: this.$root.getCategory(2, 0),
      },
      contact: this.$root.getHeader(3),
      languageControl: this.$root.getOppositeLanguage()
    };
  },
  watch: {
    language: function () {
      this.handleLanguage()
    }
  },
  mounted() {
    window.addEventListener ("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener ("scroll", this.handleScroll);
  },
  methods: {
    toggleMobileMenu () {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
    },
    handleScroll () {
      this.isScrolled = window.scrollY > 10
    },
    showDropdown (label) {
      if (!this.isMobileMenuOpen) {
        this.$set(this.dropdownVisible, label, true);
      }
    },
    hideDropdown (label) {
      if (!this.isMobileMenuOpen) {
        this.$set(this.dropdownVisible, label, false)
      }
    },
    changeLanguage: function () {
      this.$root.setLanguage(this.languageControl)
    },
    toggleMobileMenu: function () {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
    },
    handleLanguage: function () {
      this.services = this.$root.getHeader(0)
      this.about = {
        about: this.$root.getHeader(2),
        customers: this.$root.getCategory(2, 0)
      }
      this.contact = this.$root.getHeader(3)
      this.languageControl = this.$root.getOppositeLanguage()
    }
  }
}
</script>

<style scoped>

/* Dropdown Menu Styles */
.d-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  list-style: none;
  padding: 10px 0;
  margin: 0;
  z-index: 1000;
  border-radius: 0 5px 5px 5px;
  width: 300px; /* Adjust this value to make it wider */
  min-width: 200px; /* Ensure the dropdown does not shrink */
}

.d-dropdown-item {
  padding: 0;
}

.d-dropdown-item a {
  display: block;
  color: #619999 !important;
  text-decoration: none;
  transition: color 0.3s;
  font-weight: 300 !important;
  padding: 0;
}

.d-dropdown-item a:hover {
  color: #619999;
  font-weight: 700 !important;
}

/* Existing Navbar Styles */
.d-navbar {
  position: fixed;
  top: 0;
  width: 100%;
  transition: background-color 0.3s, color 0.3s;
  padding: 10px 20px;
  z-index: 1000;
  background-color: transparent;
  color: white !important;
}

.d-navbar-scrolled {
  background-color: white;
  opacity: 0.9;
  color: #619999;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
}

.d-navbar-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.d-navbar-brand {
  font-size: 30px;
  font-weight: 700;
  text-decoration: none;
  padding: 5px 0;
  color: white;
}

.d-navbar-brand-scrolled {
  color: #619999;
}

.d-navbar-menu {
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;
}

.d-navbar-item {
  margin-left: 48px;
  position: relative; /* Needed for dropdown positioning */
}

.d-navbar-item a {
  text-decoration: none;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  padding: 8px 8px;
  color: white;
}

.d-navbar-item a:hover {
  color: #619999;
  border-radius: 5px;
  background: white;
}

.d-navbar-dd-item a:hover {
  border-radius: 5px 5px 0 0;
}

.d-navbar-item-dd-hover {
  border-radius: 5px 5px 0 0;
  /*padding: 8px 8px; */
  background: white;
}

.d-navbar-item-dd-hover > a {
  color: #619999 !important;
}

.d-navbar-item-scrolled a {
  color: #619999;
}

.d-navbar-item-scrolled a:hover {
  color: #619999;
}

.languageControl {
  margin-left: 0;
  padding: 2px 5px;
}

.languageControl a {
  font-size: 12px !important;
}

.d-mobile-navbar-toggle {
  display: none;
}

@media (max-width: 768px) {
  .d-mobile-navbar-toggle {
    display: block;
  }

  .d-navbar-menu {
    display: none;
  }

  .d-mobile-navbar-btn-scrolled {
    color:#619999;
  }

  .d-mobile-navbar-btn:hover {
    cursor: pointer;
  }

  .d-mobile-navbar-menu {
    position: absolute; /* or fixed if you want it to remain fixed while scrolling */
    top: 100%; /* Push it below the navbar */
    left: 0;
    width: 100%; /* Full width of the viewport */
    background-color: white; /* Adjust to match your design */
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 999; /* Ensure it appears above other elements */
    display: flex;
    flex-direction: column; /* Vertical layout */
    align-items: flex-start; /* Align links to the left */
    padding: 10px 0;
    transition: all 0.3s ease-in-out; /* Smooth opening effect */
  }

  .d-mobile-navbar-menu a {
    padding: 10px 20px;
    text-decoration: none;
    color: #619999 !important;
    font-size: 18px;
    font-weight: 500;
    width: 100%; /* Full width clickable area */
    box-sizing: border-box;
  }

  .d-mobile-navbar-menu a:hover {
    font-weight: bold; /* Highlight on hover */
    cursor: pointer;
  }

  .d-mobile-menu-open {
    background-color: white;
    opacity: 0.9;
    color: #619999;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  }

  .d-mobile-menu-open-link {
    color: #619999;
  }
  
  .d-mobile-sub-ul {
    padding-left: 20px;
  }

  .d-mobile-sub-ul a {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavbarNEW.vue